module.exports = __webpack_public_path__ + "img/qr code.5f9d8268.svg";